import { useEffect, useState } from "react";
import { Languages, Check } from "lucide-react";
import API from "../../api";
import "./settings.css";
export default function LanguageSettings() {
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("civilink_lang") || "en"
  );

  const changeLanguage = async (lang) => {
    setSelectedLanguage(lang);

    // Save locally
    localStorage.setItem("civilink_lang", lang);

    // Save to backend
    try {
      await API.put("/users/language", {
        language: lang,
      });
    } catch {
      // Silent fail
    }

    // Reload app
    window.location.reload();
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("civilink_lang");

    if (savedLanguage) {
      setSelectedLanguage(savedLanguage);
    }
  }, []);

  const languages = [
    {
      code: "en",
      name: "English",
      nativeName: "English",
    },
    {
      code: "ta",
      name: "Tamil",
      nativeName: "தமிழ்",
    },
    {
      code: "hi",
      name: "Hindi",
      nativeName: "हिंदी",
    },
  ];

  return (
    <section className="settings-card language-settings-card">
      <div className="card-header language-header">
        <div className="settings-section-icon">
          <Languages size={20} />
        </div>

        <div>
          <h3>Language</h3>
          <p>Choose your preferred language</p>
        </div>
      </div>

      <div className="language-options">
        {languages.map((language) => {
          const isSelected = selectedLanguage === language.code;

          return (
            <button
              key={language.code}
              type="button"
              className={`language-option ${
                isSelected ? "selected" : ""
              }`}
              onClick={() => changeLanguage(language.code)}
              aria-pressed={isSelected}
            >
              <div className="language-info">
                <strong>{language.nativeName}</strong>
                <span>{language.name}</span>
              </div>

              <div className="language-check">
                {isSelected && <Check size={17} strokeWidth={2.5} />}
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}